import Trigger from 'eflex/models/trigger';

export default class WorkInstructionHardwareTrigger extends Trigger {}
